export const GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_ABORTED =
  'GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_ABORTED';
export const GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED =
  'GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED';
export const GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED =
  'GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED';
export const GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_FAILED =
  'GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_FAILED';
export const RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED =
  'RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED';
export const RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED =
  'RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED';
